import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { canRenderInputForType } from '../_helpers/hideInputForType'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import FormItem from '../../../../../../../components/form/FormItem'
import Input from '../../../../../../../components/form/Input'
import { Title } from '../../../../../../../components/presentation/Text'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'

const NumberSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChange } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  const shouldRender = canRenderInputForType(selectedQuestion.questionType.name)
  const shouldRenderMinAndMax = shouldRender('minAndMax')

  const step = selectedQuestion.questionType.name === 'float' ? 0.1 : undefined

  if (!shouldRenderMinAndMax) return false

  return (
    <>
      <Separator weight={6} />
      <Title size="h6" color={COLORS.dark4}>
        {t('numericSettings')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />

      <FormItem label={t('minValue')}>
        <Input
          small
          type="number"
          step={step}
          value={selectedQuestion.data?.minValue}
          onChange={v => handleSelectedQuestionChange('data', { ...selectedQuestion.data, minValue: v })}
        />
      </FormItem>
      <FormItem label={t('maxValue')} weight={0}>
        <Input
          small
          type="number"
          step={step}
          value={selectedQuestion.data?.maxValue}
          onChange={v => handleSelectedQuestionChange('data', { ...selectedQuestion.data, maxValue: v })}
        />
      </FormItem>
    </>
  )
}

export default NumberSection
